// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/store.js";
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import {description} from '../package.json'

Vue.use(ElementUI);
Vue.use(VueMoment, {
  moment,
});
//启动时的生产提示
Vue.config.productionTip = false;
// axios
import axios from "axios";
import Qs from "qs";
axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];
let lineURL = localStorage.getItem('lineUrl');
 
 if (!lineURL) {
   localStorage.setItem('lineUrl', process.env.API_ROOT);
   localStorage.setItem('lineUrlText', "线路一");
   localStorage.setItem('lineUrlId', "1");
   const instance = axios.create({
     baseURL: process.env.API_ROOT,
     timeout: 10000,
     withCredentials: true,
     headers: {
       "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
     }
   });
   Vue.prototype.$http = instance;
 
 } else {
// const host = process.env.NODE_ENV === "development" ? "http://api.stock.com/" : "https://pc_apiserver5618.hk9999.com/"; // 根据 process.env.NODE_ENV 的值判断当前是什么环境
const instance = axios.create({
  baseURL: localStorage.getItem('lineUrl'), //process.env.API_ROOT
  timeout: 10000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
  }
});

 // add public key encryption code when no key in local storage
 let encriptPublicKey = localStorage.getItem('encript_public_key');
 
 if (!encriptPublicKey){
   localStorage.setItem('encript_public_key', process.env.PUBLIC_ENCRYPTION_KEY);
 }

Vue.prototype.$http = instance;
}
let Line_1 = process.env.Line_1;//"https://server3299.hk99666.com/";
let Line_2 = process.env.Line_2;//"https://server3299.hk99111.com/";

Vue.prototype.$URLs = [{ "id": 1, "name": "线路一", "url": process.env.API_ROOT }, { "id": 2, "name": "线路二", "url": Line_1 }, { "id": 3, "name": "线路三", "url": Line_2 }];
// Vue.prototype.$chatApiURL = "http://localhost:9080";

Vue.prototype.$chatApiURL = "https://hkchatapp.hk9999z.com";  // for TEST
// Vue.prototype.$chatApiURL = "https://chat.hk2391.com"; // for LIVE

Vue.prototype.$dataSource= "shuhai"; //tecent,shuhai,sina
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App),//vue2.0的写法
  // components: { App }, vue1.0的写法
  template: "<App/>"
});

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});




// WEBPACK FOOTER //
// ./src/main.js